/**
 * Form control recipes (Input, Textarea, Select, NumberInput). Unifies radius
 * and brand focus ring so every text field matches without per-field
 * `focusBorderColor` props.
 */
const focusField = {
	field: {
		borderRadius: 'md',
		_focusVisible: {
			borderColor: 'brand.500',
			boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
		},
	},
};

export const Input = { baseStyle: focusField } as const;
export const Select = { baseStyle: focusField } as const;
export const NumberInput = { baseStyle: focusField } as const;

export const Textarea = {
	baseStyle: {
		borderRadius: 'md',
		_focusVisible: {
			borderColor: 'brand.500',
			boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
		},
	},
} as const;
